import React from 'react';

export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="255.874"
    height="187.107"
    viewBox="0 0 255.874 187.107"
    className={className}
  >
    <g id="Group_19933" data-name="Group 19933" transform="translate(0)">
      <path
        d="M105.32,22.314A80.05,80.05,0,0,0,99.392,182.2l72.1-124.885a79.973,79.973,0,0,0-66.174-35"
        transform="translate(-25.259 4.912)"
        fill="#fed01d"
      />
      <path
        d="M91.433,182.195A80.05,80.05,0,0,0,97.361,22.314L25.259,147.2a79.973,79.973,0,0,0,66.174,35"
        transform="translate(84.38 -22.314)"
        fill="#fed01d"
      />
    </g>
  </svg>
);
